<template>
  <div id="mytask-layout" class="theme-indigo">
    <!-- main body area -->
    <div class="main d-flex align-items-center">
      <div class="body d-flex p-0 p-xl-5" style="max-height: 95%;">
        <div v-if="isLoading" class="loadingDiv d-flex flex-column align-items-center justify-content-center w-100">
          <div class="text-center">
            <div class="d-flex align-items-baseline gap-3">
              <h3 class="text-light">Η αποστολή είναι σε εξέλιξη</h3>
              <div class="dot-flashing"></div>
            </div>
          </div>
        </div>

        <div v-else class="col-lg-12 d-flex justify-content-center align-items-center border-0 rounded-lg">
          <div class="w-100 card border-0 login-div wx-public-card" style="max-width: 50rem;">
            <!-- Logo -->
            <div class="text-center pt-4">
              <img src="../assets/images/logo.png" class="logo-img" style="width: 300px;" alt="Citrine Logo" />
            </div>

            <!-- Header -->
            <div class="text-center px-4 pt-3">
              <h3 class="fw-bold">Συμπλήρωση Φόρμας Πρόσληψης</h3>
              <h4 class="mt-3">Εισάγετε τα στοιχεία σας.</h4>
            </div>

            <!-- Form -->
            <form class="row g-3 px-4 py-4" @submit.prevent="handleSubmit">

              <!-- Group 1: Basic Info -->
              <div class="col-sm-6">
                <label class="form-label">Name</label>
                <input type="text" class="form-control" v-model="form.name" />
              </div>
              <div class="col-sm-6">
                <label class="form-label">Surname</label>
                <input type="text" class="form-control" v-model="form.surname" />
              </div>
              <div class="col-sm-6">
                <label class="form-label">Father Name</label>
                <input type="text" class="form-control" v-model="form.fatherFullName" />
              </div>
              <div class="col-sm-6">
                <label class="form-label">Mother Name</label>
                <input type="text" class="form-control" v-model="form.motherFullName" />
              </div>
              <div class="col-12">
                <label class="form-label">Spouse Fullname</label>
                <input type="text" class="form-control" v-model="form.spouseFullName" />
              </div>

              <!-- Identity -->
              <div class="col-sm-6">
                <label class="form-label">Identity Type</label>
                <select class="form-select" v-model="form.identityType">
                  <option value="Αστυνομική Ταυτότητα">ID</option>
                  <option value="Passport">Passport</option>
                </select>
              </div>
              <div class="col-sm-6">
                <label class="form-label">Identity Code</label>
                <input type="text" class="form-control" v-model="form.identityNum" />
              </div>
              <div class="col-sm-6">
                <label class="form-label">Ημερ. Έκδοσης Ταυτότητας</label>
                <input type="date" class="form-control" v-model="form.identityCreationDate" />
              </div>
              <div class="col-sm-6">
                <label class="form-label">Έκδουσα Αρχή</label>
                <input type="text" class="form-control" v-model="form.identityCreationDepartment" />
              </div>

              <!-- Tax Info -->
              <div class="col-sm-6">
                <label class="form-label">AFM</label>
                <input type="number" class="form-control" v-model="form.afm" />
              </div>
              <div class="col-sm-6">
                <label class="form-label">ΔΟΥ</label>
                <input type="text" class="form-control" v-model="form.doy" />
              </div>

              <!-- Insurance Info -->
              <div class="col-sm-6">
                <label class="form-label">ΑΜ ΙΚΑ</label>
                <input type="text" class="form-control" v-model="form.amIka" />
              </div>
              <div class="col-sm-6">
                <label class="form-label">ΑΜΚΑ</label>
                <input type="number" class="form-control" v-model="form.amka" />
              </div>
              <div class="col-sm-6">
                <label class="form-label">ΑΜ Άλλου Ταμείου</label>
                <input type="text" class="form-control" v-model="form.amMiscDepartment" />
              </div>
              <div class="col-sm-6">
                <label class="form-label">Tax Email</label>
                <input type="email" class="form-control" v-model="form.taxEmail" />
              </div>

              <div class="col-sm-6">
                <label class="form-label">Ημερ. Γεννήσεως</label>
                <input type="date" class="form-control" v-model="form.birthday" />
              </div>
              <div class="col-sm-6">
                <label class="form-label">Τόπος Γεννήσεως</label>
                <input type="text" class="form-control" v-model="form.birthplace" />
              </div>
              <div class="col-sm-6">
                <label class="form-label">Ιθαγένεια</label>
                <input type="text" class="form-control" v-model="form.nationality" />
              </div>

              <!-- Address Info -->
              <div class="col-sm-6">
                <label class="form-label">Διεύθυνση</label>
                <input type="text" class="form-control" v-model="form.address" />
              </div>
              <div class="col-sm-3">
                <label class="form-label">Περιοχή</label>
                <input type="text" class="form-control" v-model="form.area" />
              </div>
              <div class="col-sm-3">
                <label class="form-label">ΤΚ</label>
                <input type="text" class="form-control" v-model="form.postal" />
              </div>
              <div class="col-sm-6">
                <label class="form-label">Δημοτικό Διαμέρισμα</label>
                <input type="text" class="form-control" v-model="form.municipality" />
              </div>
              <div class="col-sm-3">
                <label class="form-label">Τηλέφωνο</label>
                <input type="tel" class="form-control" v-model="form.tel" />
              </div>
              <div class="col-sm-3">
                <label class="form-label">Οικ. Κατάσταση</label>
                <select class="form-select" v-model="form.maritalStatus">
                  <option value="Άγαμος-η">Άγαμος-η</option>
                  <option value="Έγγαμος-η">Έγγαμος-η</option>
                  <option value="Διαζευγμένος-η">Διαζευγμένος-η</option>
                </select>
              </div>


              <!-- Driving & Insurance -->
              <div class="col-sm-6">
                <label class="form-label">Αρ. Άδειας Οδήγησης</label>
                <input type="text" class="form-control" v-model="form.drivingLicense" />
              </div>
              <div class="col-sm-3">
                <label class="form-label">Έτος Πρώτης Ασφάλισης</label>
                <input type="text" class="form-control" v-model="form.yearOfFirstInsurance" />
              </div>
              <div class="col-sm-3">
                <label class="form-label">Αριθμός Τέκνων</label>
                <input type="number" class="form-control" min="0" v-model="form.numberOfChildren" />
              </div>

              <!-- Contributions -->
              <div class="col-sm-6">
                <label class="form-label">Ένσημα - Σύνολο</label>
                <input type="text" class="form-control" v-model="form.insuranceContributionsTotal" />
              </div>
              <div class="col-sm-6">
                <label class="form-label">Ένσημα - Ειδικότητα</label>
                <input type="text" class="form-control" v-model="form.insuranceContributionsSpecialty" />
              </div>

               <div class="col-sm-6">
                <label class="form-label">Ωράριο</label>
                <input type="text" class="form-control" v-model="form.workingHours" />
              </div>
              <div class="col-sm-6">
                <label class="form-label">Μικτός Μισθός</label>
                <input type="text" class="form-control" v-model="form.grossSalary" />
              </div>

              <!-- Submit -->
              <div class="col-12 text-center mt-4">
                <button type="submit" class="btn btn-register btn-secondary">
                  <b>Υποβολή</b>
                </button>
              </div>
            </form>
          </div>
        </div>
        <div id="extra-content"></div>
      </div>
    </div>
  </div>
</template>


<script>
import '../assets/js/bundles/libscripts.bundle.js';
import { ref, onMounted, onUnmounted } from 'vue';
import { submitEmployeeForm } from '../services/auth.js';
import { useToast } from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import { useRoute, useRouter } from 'vue-router';



export default {
    name: 'NewEmployeeForm',
    
    setup() {
        const route = useRoute(); 
    const router = useRouter();

        const form = ref({
    name: '',
    surname: '',
    fatherFullName: '',
    motherFullName: '',
    spouseFullName: '',
    identityType: '',
    identityNum: '',
    identityCreationDate: '',
    identityCreationDepartment: '',
    afm: '',
    doy: '',
    amIka: '',
    amka: '',
    amMiscDepartment: '',
    taxEmail: '',
    total_days_off: '',
    birthday: '',
    birthplace: '',
    nationality: '',
    address: '',
    area: '',
    postal: '',
    municipality: '',
    tel: '',
    grossSalary : "",
    workingHours : "",
    maritalStatus: '',
    drivingLicense: '',
    yearOfFirstInsurance: '',
    numberOfChildren: '',
    insuranceContributionsTotal: '',
    insuranceContributionsSpecialty: ''
});

        
        const isLoading = ref(false);
        const errorMessage = ref('');
        const successMessage = ref('');

        const toast = useToast();

        const handleSubmit = async () => {
            isLoading.value = true;
            try {
                const payload = {
                    ...form.value,
                    code: route.query.code || '' 
                };

                const response = await submitEmployeeForm(payload);
                if (response.data?.success) {
                    successMessage.value = response.data.message;
                    // Use the toast instance to show success message
                    toast.success(response.data.message);
                    setTimeout(() => {
                        // Redirect after 2 seconds
                        router.push('/login');
                    }, 2000);
                } else {
                    errorMessage.value = response.data.message;
                    // Use the toast instance to show error message
                    toast.error(response.data.message);
                }
            } catch (error) {
                console.error('Registration error:', error);
                errorMessage.value = 'An error occurred while submitting the form. Please try again later.';
                // Show error toast
                toast.error('An error occurred while submitting the form. Please try again later.');
            } finally {
                isLoading.value = false;
            }
        };



        const handleKeyPressed = (event) => {
            if (event.key == 'Enter') {
                document.querySelector('.btn-register').click();
            }
        };

        onMounted(() => {
            document.addEventListener('keyup', handleKeyPressed);
        });

        onUnmounted(() => {
            document.removeEventListener('keyup', handleKeyPressed);
        });

       

        return {
            form,
            isLoading,
            errorMessage,
            successMessage,
            handleSubmit
        };
    }
};
</script>

<style>
/* Styles specific to login view */
</style>